import { render, staticRenderFns } from "./KtaList.vue?vue&type=template&id=40a87b5f&"
import script from "./KtaList.vue?vue&type=script&lang=js&"
export * from "./KtaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports